import {
  Modal,
  ModalOverlay,
  ModalContent,
  Flex,
  ModalBody,
  ModalCloseButton,
  useMediaQuery,
} from "@chakra-ui/react";
import SuccessModalBody from "./SuccessModalBody";
import ErrorModalBody from "./ErrorModalBody";
import ButtonSpoleto from "../Button";
import TitleSpoleto from "../Title";
import ButtonVote from "./ThemeButton";
import { useState } from "react";
import axios from "axios";

const MODAL_STATE = {
  SUCCESS: "success",
  ERROR: "error",
  PENDING: "pending",
};

const PENDING_MODAL_BG = "#EFEBE1";
const SUCCESS_MODAL_BG = "#215342";
const ERROR_MODAL_BG = "red.500";

const PENDING_CLOSE_ICON_BG = "#331F12";
const WHITE_COLOR = "#FFF";

const VoteModal = ({ isOpen, toggleVoteModal }) => {
  const [isDesktop] = useMediaQuery("(min-width: 992px)");
  const modalSize = isDesktop ? "xl" : "sm";

  const [themeSelected, setTheme] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [modalState, setModalState] = useState(MODAL_STATE.PENDING);

  const isDisabled = Boolean(!themeSelected);

  const onButtonClick = (themeId) => {
    setTheme(themeId);
  };

  const getModalBG = () => {
    if (modalState === MODAL_STATE.PENDING) return PENDING_MODAL_BG;
    if (modalState === MODAL_STATE.SUCCESS) return SUCCESS_MODAL_BG;
    if (modalState === MODAL_STATE.ERROR) return ERROR_MODAL_BG;
  };

  const getCloseIconBG = () => {
    if (modalState === MODAL_STATE.PENDING) return PENDING_CLOSE_ICON_BG;
    return WHITE_COLOR;
  };

  const closeModal = () => {
    setModalState(MODAL_STATE.PENDING);
    toggleVoteModal();
  };

  const submitVote = () => {
    if (!themeSelected) return false;
    setLoading(true);
    const payload = { theme: [themeSelected] };
    return axios
      .post(
        "https://backendpratos.spoletoitalian.com/api/postthemepublicvote",
        payload,
        {
          headers: {
            "Content-Type": `application/json`,
            Authorization: "Basic ZnJvbnQ6MTkyMzQx",
          },
        }
      )
      .then(() => {
        setModalState(MODAL_STATE.SUCCESS);
      })
      .catch(() => {
        setModalState(MODAL_STATE.ERROR);
      })
      .finally(() => {
        setLoading(false);
        setTheme(null);
      });
  };

  return (
    <Modal
      size={modalSize}
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={toggleVoteModal}
      isCentered
      zIndex="99999"
    >
      <ModalOverlay />
      <ModalContent bg={getModalBG()} maxH="80vh" overflow="auto">
        <ModalCloseButton color={getCloseIconBG()} size="lg" />
        <ModalBody pb={6}>
          {modalState === MODAL_STATE.SUCCESS && (
            <SuccessModalBody closeModal={closeModal} />
          )}
          {modalState === MODAL_STATE.ERROR && (
            <ErrorModalBody closeModal={closeModal} />
          )}
          {modalState === MODAL_STATE.PENDING && (
            <Flex w="100%" py={12} alignItems="center" flexDirection="column">
              <TitleSpoleto
                textAlign="center"
                fontSize={["30px", null, "40px"]}
              >
                ESCOLHA SEU <br /> TEMA FAVORITO
              </TitleSpoleto>
              <Flex
                w="100%"
                my={[8, null, 16]}
                flexDirection={["column", null, "row"]}
                alignItems={["center", null, "start"]}
                justifyContent="space-between"
              >
                <ButtonVote
                  src="assets/images/vote-music-magic.png"
                  name="Magia da Música"
                  id={1}
                  themeSelected={themeSelected}
                  onClick={() => onButtonClick(1)}
                />
                <ButtonVote
                  src="assets/images/vote-nostalgia.png"
                  name="Nostalgia"
                  id={2}
                  themeSelected={themeSelected}
                  onClick={() => onButtonClick(2)}
                  my={[10, null, 0]}
                />
                <ButtonVote
                  src="assets/images/vote-natural-prints.png"
                  name="Estampas da Natureza"
                  id={3}
                  themeSelected={themeSelected}
                  onClick={() => onButtonClick(3)}
                />
              </Flex>
              <ButtonSpoleto
                backgroundColor="#215342"
                color="#EFEBE1"
                shadow="0 0 0 2px #EFEBE1"
                maxWidth={["75%", null, "90%"]}
                isDisabled={isDisabled}
                isLoading={isLoading}
                onClick={submitVote}
              >
                Confirmar
              </ButtonSpoleto>
            </Flex>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default VoteModal;
